import { FC } from "react";
import { Wrapper } from "./Table.styled";
import parse from "html-react-parser";

interface Props {
  markup?: string;
}

const Table: FC<Props> = ({ markup }) => {
  if (!markup) {
    return null;
  }
  return <Wrapper>{parse(markup)}</Wrapper>;
};
export default Table;
